export default __webpack_public_path__ + "static/media/photo.64b7054a.png";